// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.patient.PatientCommunicationPreferencesRequest */
/* istanbul ignore next */
@GandalfModel
export class PatientCommunicationPreferencesRequest extends GandalfModelBase {

	@GandalfLabel('Appointments Cell Phone Allowed')
	@GandalfProperty({ designType: Boolean })
	appointmentsCellPhoneAllowed!: boolean | null;

	@GandalfLabel('Appointments Email Allowed')
	@GandalfProperty({ designType: Boolean })
	appointmentsEmailAllowed!: boolean | null;

	@GandalfLabel('Appointments Home Phone Allowed')
	@GandalfProperty({ designType: Boolean })
	appointmentsHomePhoneAllowed!: boolean | null;

	@GandalfLabel('Appointments Mail Allowed')
	@GandalfProperty({ designType: Boolean })
	appointmentsMailAllowed!: boolean | null;

	@GandalfConstantDecorator(constants.PatientCommunicationOptIn)
	@GandalfLabel('Appointments Opt In')
	@GandalfProperty({ designType: constants.PatientCommunicationOptIn })
	appointmentsOptIn!: constants.PatientCommunicationOptIn | null;

	@GandalfLabel('Appointments Text Allowed')
	@GandalfProperty({ designType: Boolean })
	appointmentsTextAllowed!: boolean | null;

	@GandalfLabel('Appointments Work Phone Allowed')
	@GandalfProperty({ designType: Boolean })
	appointmentsWorkPhoneAllowed!: boolean | null;

	@GandalfLabel('Comments')
	@GandalfValidator({ sizeString: { message: 'Comments cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	comments!: string | null;

	@GandalfLabel('Do Not Call Cell')
	@GandalfProperty({ designType: Boolean })
	doNotCallCell!: boolean | null;

	@GandalfLabel('Do Not Call Home')
	@GandalfProperty({ designType: Boolean })
	doNotCallHome!: boolean | null;

	@GandalfLabel('Do Not Call Work')
	@GandalfProperty({ designType: Boolean })
	doNotCallWork!: boolean | null;

	@GandalfLabel('Do Not Email')
	@GandalfProperty({ designType: Boolean })
	doNotEmail!: boolean | null;

	@GandalfLabel('Do Not Mail')
	@GandalfProperty({ designType: Boolean })
	doNotMail!: boolean | null;

	@GandalfLabel('Do Not Text')
	@GandalfProperty({ designType: Boolean })
	doNotText!: boolean | null;

	@GandalfLabel('General Cell Phone Allowed')
	@GandalfProperty({ designType: Boolean })
	generalCellPhoneAllowed!: boolean | null;

	@GandalfLabel('General Email Allowed')
	@GandalfProperty({ designType: Boolean })
	generalEmailAllowed!: boolean | null;

	@GandalfLabel('General Home Phone Allowed')
	@GandalfProperty({ designType: Boolean })
	generalHomePhoneAllowed!: boolean | null;

	@GandalfLabel('General Mail Allowed')
	@GandalfProperty({ designType: Boolean })
	generalMailAllowed!: boolean | null;

	@GandalfConstantDecorator(constants.PatientCommunicationOptIn)
	@GandalfLabel('General Opt In')
	@GandalfProperty({ designType: constants.PatientCommunicationOptIn })
	generalOptIn!: constants.PatientCommunicationOptIn | null;

	@GandalfLabel('General Text Allowed')
	@GandalfProperty({ designType: Boolean })
	generalTextAllowed!: boolean | null;

	@GandalfLabel('General Work Phone Allowed')
	@GandalfProperty({ designType: Boolean })
	generalWorkPhoneAllowed!: boolean | null;

	@GandalfLabel('Orders Cell Phone Allowed')
	@GandalfProperty({ designType: Boolean })
	ordersCellPhoneAllowed!: boolean | null;

	@GandalfLabel('Orders Email Allowed')
	@GandalfProperty({ designType: Boolean })
	ordersEmailAllowed!: boolean | null;

	@GandalfLabel('Orders Home Phone Allowed')
	@GandalfProperty({ designType: Boolean })
	ordersHomePhoneAllowed!: boolean | null;

	@GandalfLabel('Orders Mail Allowed')
	@GandalfProperty({ designType: Boolean })
	ordersMailAllowed!: boolean | null;

	@GandalfConstantDecorator(constants.PatientCommunicationOptIn)
	@GandalfLabel('Orders Opt In')
	@GandalfProperty({ designType: constants.PatientCommunicationOptIn })
	ordersOptIn!: constants.PatientCommunicationOptIn | null;

	@GandalfLabel('Orders Text Allowed')
	@GandalfProperty({ designType: Boolean })
	ordersTextAllowed!: boolean | null;

	@GandalfLabel('Orders Work Phone Allowed')
	@GandalfProperty({ designType: Boolean })
	ordersWorkPhoneAllowed!: boolean | null;

	@GandalfLabel('Recalls Cell Phone Allowed')
	@GandalfProperty({ designType: Boolean })
	recallsCellPhoneAllowed!: boolean | null;

	@GandalfLabel('Recalls Email Allowed')
	@GandalfProperty({ designType: Boolean })
	recallsEmailAllowed!: boolean | null;

	@GandalfLabel('Recalls Home Phone Allowed')
	@GandalfProperty({ designType: Boolean })
	recallsHomePhoneAllowed!: boolean | null;

	@GandalfLabel('Recalls Mail Allowed')
	@GandalfProperty({ designType: Boolean })
	recallsMailAllowed!: boolean | null;

	@GandalfConstantDecorator(constants.PatientCommunicationOptIn)
	@GandalfLabel('Recalls Opt In')
	@GandalfProperty({ designType: constants.PatientCommunicationOptIn })
	recallsOptIn!: constants.PatientCommunicationOptIn | null;

	@GandalfLabel('Recalls Text Allowed')
	@GandalfProperty({ designType: Boolean })
	recallsTextAllowed!: boolean | null;

	@GandalfLabel('Recalls Work Phone Allowed')
	@GandalfProperty({ designType: Boolean })
	recallsWorkPhoneAllowed!: boolean | null;

}
